/* eslint react/prop-types: 0 */

import React from 'react';
import { Result, Typography } from 'antd';
const { Link } = Typography;
const Finish = (props) => {
  return (
    <Result
      status={props.status || 'info'}
      title="Мы отправили на вашу почту письмо с ссылкой для подтверждения"
      subTitle={[
        'Если вы его не получили, напишите нам на ',
        <Link key="mailto" mailto="itdep@lanbilling.ru" target="_blank">
          itdep@lanbilling.ru
        </Link>,
        ' или позвоните +7 (495) 795-06-77'
      ]}
    />
  );
};

export default Finish;
